export const en = {
    'age-restriction': 'Age restriction should be selected',
    'apk-empty-platform-list': 'Select at least one target platform',
    'already-exist': 'An application with the same name already exists',
    'common-names': 'Too common phrases',
    'empty-description': 'Write a description of the application',
    'empty-short-description': 'Write a short description of the application',
    'forbidden-words': 'Contains forbidden words',
    'name-is-required': 'Name is a required field',
    'name-quouted': "The application's name is quoted",
    'package-name-missing': 'The package name is missing',
    'too-common-phrases': 'The name or activation phrases are too common',
    'too-long': 'It cannot contain more than {characters} characters',
    'validation-developer-name': 'Developer name cannot contain {word}',
    'validation-email': 'Incorrect email address was entered',
    'validation-url': 'Invalid URL entered',
    'wrong-package-name': 'Incorrect package name format',
    'unknown-error': 'Unknown error',
    'apk-upload-error': 'Upload Error',
    'network-error': 'Check your internet connection',
    'activation-name-is-the-same': 'The activation name synonym must differ from the previous one',
    'activation-name-already-registered': 'The activation name is already registered',
    'app-name-already-exist': 'An application with this name already exists',
    'package-name-already-exist': 'An application with this package name already exists',
    'upload-file-size': 'The file size exceeds ',
    "megabytes": " MB",
    'need-html-file': 'The file must be in .html format',
    'need-apk-file': 'The file must be in .apk format',
    'network': 'Network error',
    "saved-package-name": "Published name",
    "and-uploaded": "and uploaded",
    "not-same": "not equals",
    "need-esia-profile-title": "Verify your account",
    "need-esia-profile-text": "You need to verify your account by linking it to your Gosuslugi (Government Services) account.",
    "go-to-esia": "Link account",
    "link": "Link",
    "need-link-porg-to-gosuslugi": "To proceed, you must verify your organization through Gosuslugi. Learn more in the [Documentation].",
    "porg-verification-required": "Organization verification required",
    'validation-error': 'Validation error',
    'app-version-downgrade': 'Application version is lower than the previous one',
    'same-as-published-app-version-code': 'An application version with this code has already been published',
    'package-name-diff': 'Package name differs from the one already saved',
    'apk-illegal-permission': 'APK contains prohibited permissions',
    'invalid-structured-example': 'The request must not contain prohibited/forbidden words',
    'invalid-structured-example-has-activation-name': 'The request must not contain the activation name',
    'app-name-min-words-limit': 'Name contains too few words',
    'app-name-max-words-limit': 'Name contains too many words',
    'activation-phrases-min-words-limit': 'Activation phrase contains too few words',
    'activation-phrases-max-words-limit': 'Activation phrase contains too many words',
    'cloud-functions-are-not-allowed-for-official-skills': 'Cloud functions are not available for official skills',
    'max-length-limit': 'Too long',
    'file-size-limit': 'File is too large',
    'file-wrong-format': 'Invalid file format',
    'file-name-is-absent': 'File name is missing',
    'intent-empty-form-name': 'Empty name',
    'intent-form-name-unique': 'Name must be unique',
    'share-limit-exceed': 'Access-sharing limit reached',
    'failed-to-verify-url': 'Site verification failed',
    'not-all-devices-supported': 'All apk files have minSdkVersion higher than {sdkVersion}. The application will not be displayed on some devices. You can add another apk with the required minSdkVersion',
    'min-sdk-version-not-supported': 'Application minSdkVersion is too high',
    'apk-parse-error': 'Invalid apk file',
    'apk-check-failed': 'Installing this application via the platform is currently unavailable'
} as const;
export const ru = {
    'age-restriction': 'Необходимо указать возрастное ограничение',
    'apk-empty-platform-list': 'Выберите хотя бы одну платформу распространения',
    'already-exist': 'Приложение с таким именем уже существует',
    'common-names': 'Слишком общие фразы',
    'empty-description': 'Напишите описание приложения',
    'empty-short-description': 'Напишите короткое описание приложения',
    'forbidden-words': 'Содержит запрещенные слова',
    'name-is-required': 'Необходимо указать название',
    'name-quouted': 'Название приложения в кавычках',
    'package-name-missing': 'Отсутствует имя пакета',
    'too-common-phrases': 'Название или фразы активации слишком общие. Заполните поле "Сайт для верификации прав использования бренда"',
    'too-long': 'Не может содержать более {characters} символов',
    'validation-developer-name': 'Имя разработчика не может содержать {word}',
    'validation-email': 'Введен некорректный email',
    'validation-url': 'Введен неверный URL',
    'wrong-package-name': 'Некорректный формат имени пакета',
    'unknown-error': 'Неизвестная ошибка',
    'apk-upload-error': 'Ошибка загрузки',
    'network-error': 'Проверьте подключение к Интернету',
    'activation-name-is-the-same': "Синоним имени должен отличаться от предыдущего",
    'activation-name-already-registered': "Активационное имя уже зарегистрировано",
    'app-name-already-exist': "Приложение с таким именем уже существует",
    'package-name-already-exist': "Уже существует приложение с таким именем пакета",
    "upload-file-size": "Размер файла больше чем ",
    "megabytes": " Мб",
    "need-html-file": "Файл должен быть в формате .html",
    "need-apk-file": "Файл должен быть в формате .apk",
    "network": "Ошибка сети",
    "saved-package-name": "Опубликованное имя ",
    "and-uploaded": "и загруженное",
    "not-same": "не равны",
    "need-esia-profile-title": "Подтвердите аккаунт",
    "need-esia-profile-text": "Необходимо подтвердить аккаунт, привязав его к учетной записи ГосУслуг.",
    "go-to-esia": "Привязать аккаунт",
    "link": "Привязать",
    "need-link-porg-to-gosuslugi": "Для продолжения необходимо подтвердить вашу организацию через ГосУслуги. Подробнее в [Документации]",
    "porg-verification-required": "Организация не верифицирована",
    'validation-error': 'Ошибка валидации',
    'app-version-downgrade': 'Версия приложения ниже предыдущей версии',
    'same-as-published-app-version-code': 'Версия приложения с таким кодом уже опубликована',
    'package-name-diff': 'Имя пакета отличается от ранее сохранённого',
    'apk-illegal-permission': 'APK имеет запрещенные permissions',
    'invalid-structured-example': 'Запрос не должен содержать запрещенные слова',
    'invalid-structured-example-has-activation-name': 'Запрос не должен содержать активационное имя',
    'app-name-min-words-limit': 'Имя содержит слишком мало слов',
    'app-name-max-words-limit': 'Имя содержит слишком много слов',
    'activation-phrases-min-words-limit': 'Мало слов в активационной фразе',
    'activation-phrases-max-words-limit': 'Много слов в активационной фразе',
    'cloud-functions-are-not-allowed-for-official-skills': 'Облачные функции недоступны в официальных навыках',
    'max-length-limit': 'Превышена максимальная длина',
    'file-size-limit': 'Файл слишком большой',
    'file-wrong-format': 'Файл неправильного формата',
    'file-name-is-absent': 'Нет имени файла',
    'intent-empty-form-name': 'Пустое имя',
    'intent-form-name-unique': 'Имя не должно повторяться',
    'share-limit-exceed': 'Достигнут лимит на выдачу доступа',
    'failed-to-verify-url': 'Не удалось подтвердить сайт',
    'not-all-devices-supported': 'У всех apk minSdkVersion выше, чем {sdkVersion}. На некоторых девайсах приложение не будет отображаться. Вы можете добавить еще одну apk с нужным minSdkVersion',
    'min-sdk-version-not-supported': 'У приложения слишком высокий minSdkVersion',
    'apk-parse-error': 'Невалидный apk файл',
    'apk-check-failed': 'Установка этого приложения через платформу сейчас недоступна'
} as const;
